import http from "@utils/request";

// 获取站点列表
export const siteList=()=>http({
  url: "/phemsjava/siteList"
});

// 获取数据库列表
export const getListDb = () => http({
  url: "/user/getDb"
})

// 测试数据库
export const testDb = (dbname) => http({
  method: "GET",
  url: "/api/testDb",
  data:{
    dbname:dbname
  }
});
// 获取用户数据库配置
export const getConfig = () => http({//获取配置数据
  method: "POST",
  url: "/phemsjava/getConfig",
  data: {},
});

/**
 * 获取用户自定义配置
 */
export const getUserFreeSettings=()=>http({
  method:"POST",
  url:"/user/getUserFreeSettings"
});

export const setUserFreeSettings=(config)=>http({
  method:"POST",
  url:"/user/setUserFreeSettings",
  data:{
    config
  }
});

/**
 * 检查临时登录客户端token时候有效
 */
export const checkClientlogin=(token)=>http({
  method:"POST",
  url:"/user/checkClientlogin",
  data:{
    token
  }
});

/**
 * 检查token时候有效
 */
 export const checkloginByToken=(token)=>http({
  method:"POST",
  url:"/user/checkloginByToken",
  data:{
    token
  }
});

/**
 * 退出登录
 */
export const logout=()=>http({
  method:"POST",
  url:"/user/logout"
});


